<template>
  <div class="container">
    <div class="d-flex justify-center">
      <router-link to="/" class="text-decoration-none m-4 p-4 m-md-5">
        <div class="d-flex align-center justify-center mb-3">
          <img src="@/assets/logo.png" width="40" alt="" />
          <p class="mb-0 fw-700 fz-30 ml-4">
            <span style="color: #03428b"><b>SILAJU</b></span>
          </p>
        </div>
        <p class="text-muted text-center">
          <b>Sistem Lapor Jual Kendaraan Bermotor</b>
        </p>
      </router-link>
    </div>

    <div class="row justify-center">
      <div class="col-12 col-md-7 col-lg-5 col-xl-4">
        <v-form ref="formLogin" @submit.prevent="handleLogin">
          <h2 class="fz-24 fw-700 mb-5">Sign In</h2>
          <div class="mb-1">
            <label for="" class="mb-3">NIK</label>
            <v-text-field
              solo
              placeholder="Nomor NIK"
              v-model="username"
              dense
              filled
              class="input-primary"
              :rules="[
                (value) => {
                  return genericRequiredRule(value, 'Nomor NIK');
                },
                (value) => {
                  return generic16DigitRule(value, 'Nomor NIK');
                },
              ]"
            />
          </div>
          <div class="">
            <label for="" class="mb-3">Password</label>
            <v-text-field
              solo
              placeholder="Masukkan Password"
              type="password"
              v-model="pw"
              dense
              filled
              class="input-primary"
              :rules="[
                (value) => {
                  return genericRequiredRule(value, 'Password');
                },
              ]"
            />
          </div>
          <p class="fz-14 fw-500 text-right mb-5">
            <router-link to="/forgot-password">lupa password?</router-link>
          </p>
          <div class="">
            <v-btn type="submit" class="btn btn-primary w-100 py-5" rounded>
              Sign In
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
    <br />
    <div class="d-flex justify-center">
      <p class="fz-14 fw-500 mb-5">
        Belum punya akun? <router-link to="/register">Sign Up</router-link>
      </p>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import { FieldRequired } from "@/mixins/ValidationRules";

export default {
  name: "Login",
  mixins: [FieldRequired],
  computed: {
    username: {
      get() {
        return this.$store.state.app.login.username;
      },
      set(val) {
        this.$store.commit("SET_FORM_LOGIN", {
          key: "username",
          value: val,
        });
      },
    },
    pw: {
      get() {
        return this.$store.state.app.login.pw;
      },
      set(val) {
        this.$store.commit("SET_FORM_LOGIN", {
          key: "pw",
          value: val,
        });
      },
    },
  },
  methods: {
    handleLogin() {
      if (this.$refs.formLogin.validate()) {
        this.$store.dispatch("AuthLogin");
      }
      this.$refs.formLogin.reset();
    },
  },
};
</script>
